import { render } from "./AppHeader.vue?vue&type=template&id=21016c99&scoped=true"
import script from "./AppHeader.vue?vue&type=script&lang=js"
export * from "./AppHeader.vue?vue&type=script&lang=js"

import "./AppHeader.vue?vue&type=style&index=0&id=21016c99&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-21016c99"

export default script